<div class="modal-content pt-0 ">
  <div class="modal-header">
    <h4 class="modal-title">
      {{ 'busbarOrCoverArticleWizardPopup.label.title' | translate }}
    </h4>
  </div>

  <div class="modal-body pt-0"
       [formGroup]="editNBusbar">
    <div class="modal-body-inner">
      <p class="middle font-weight-bold">{{'busbarOrCoverArticleWizardPopup.label.header' | translate}}</p>

      <div class="mb-3 row">
        <label class="col-md-5 col-form-label font-weight-bold">
          {{'busbarOrCoverArticleWizardPopup.label.start_offset_length' | translate}}: *
        </label>
        <div class="col-md">
          <div class="input-group">
            <input class="form-control"
                   type="text"
                   [class.is-invalid]="editNBusbar.controls.additionalStartLengthInput.invalid"
                   inputRestricter="^[0-9\.,]*$"
                   formControlName="additionalStartLengthInput"
                   (inputEvent)="editNBusbar.controls.additionalStartLengthInput.setValue($event)">
            <div class="input-group-append"><span class="input-group-text">{{'global.unit.label.mm' | translate }}</span></div>
            <div class="invalid-feedback">{{ editNBusbar.errors?.messageKey | translate: {'0': editNBusbar.errors?.param} }}</div>
            <div class="invalid-feedback">{{ editNBusbar.controls.additionalStartLengthInput.errors?.messageKey | translate: {'0': editNBusbar.controls.additionalStartLengthInput.errors?.param} }}</div>
          </div>
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-md-5 col-form-label font-weight-bold">
          {{'busbarOrCoverArticleWizardPopup.label.length' | translate}}:
        </label>
        <div class="col-md">
          <div class="input-group">
            <input class="form-control"
                   type="text"
                   readonly
                   inputRestricter="^[0-9\.,]*$"
                   formControlName="lengthInput">
            <div class="input-group-append"><span class="input-group-text">{{'global.unit.label.mm' | translate }}</span></div>
          </div>
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-md-5 col-form-label font-weight-bold">
          {{'busbarOrCoverArticleWizardPopup.label.end_offset_length' | translate}}: *
        </label>
        <div class="col-md">
          <div class="input-group">
            <input class="form-control"
                   type="text"
                   [class.is-invalid]="editNBusbar.controls.additionalEndLengthInput.invalid"
                   inputRestricter="^[0-9\.,]*$"
                   formControlName="additionalEndLengthInput"
                   (inputEvent)="editNBusbar.controls.additionalEndLengthInput.setValue($event)">
            <div class="input-group-append"><span class="input-group-text">{{'global.unit.label.mm' | translate }}</span></div>
            <div class="invalid-feedback">{{ editNBusbar.errors?.messageKey | translate: {'0': editNBusbar.errors?.param} }}</div>
            <div class="invalid-feedback">{{ editNBusbar.controls.additionalEndLengthInput.errors?.messageKey | translate: {'0': editNBusbar.controls.additionalEndLengthInput.errors?.param} }}</div>
          </div>
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-md-5 col-form-label font-weight-bold">
          {{'busbarOrCoverArticleWizardPopup.label.projectLength' | translate}}:
        </label>
        <div class="col-md">
          <div class="input-group">
            <input class="form-control"
                   readonly
                   [value]="currentLengthBusbarProject"
                   type="text">
            <div class="input-group-append"><span class="input-group-text">{{'global.unit.label.mm' | translate }}</span></div>
          </div>
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-md-5 col-form-label font-weight-bold">
          {{'busbarOrCoverArticleWizardPopup.label.maxLength' | translate}}:
        </label>
        <div class="col-md">
          <div class="input-group">
            <input class="form-control"
                   readonly
                   type="text"
                   formControlName="busbarMaxLengthInput">
            <div class="input-group-append"><span class="input-group-text">{{'global.unit.label.mm' | translate }}</span></div>
          </div>
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-md-5 col-form-label font-weight-bold">
          {{'busbarOrCoverArticleWizardPopup.label.from_start_to_first' | translate}}:
        </label>
        <div class="col-md">
          <div class="input-group">
            <input class="form-control"
                   formControlName="distanceToFirstArticleLabel"
                   readonly
                   type="text">
            <div class="input-group-append"><span class="input-group-text">{{'global.unit.label.mm' | translate }}</span></div>
          </div>
        </div>
      </div>

      <div class="mb-3 row">
        <label class="col-md-5 col-form-label font-weight-bold">
          {{'busbarOrCoverArticleWizardPopup.label.from_start_to_last' | translate}}:
        </label>
        <div class="col-md">
          <div class="input-group">
            <input class="form-control"
                   formControlName="distanceToLastArticleLabel"
                   readonly
                   type="text">
            <div class="input-group-append"><span class="input-group-text">{{'global.unit.label.mm' | translate }}</span></div>
          </div>
        </div>
      </div>

    </div>
  </div>

  <div class="modal-footer">
    <button class="btn btn-secondary btn-cancel"
            type="button"
            (click)="close()">{{'global.label.cancel' | translate}}
    </button>
    <button class="btn btn-primary btn-forward"
            type="submit"
            [disabled]="!this.editNBusbar.valid"
            (click)="submit()">
      {{'global.label.accept' | translate}}
    </button>
  </div>
</div>
